module.exports = __webpack_public_path__ + "img/trash_outlined_24.82516fc6.svg";